module.exports = __webpack_public_path__ + "static/media/iconSupport.2686c70a.svg";